// Export PrioritizeAndDecide component
import PrioritizeAndDecide from "./PrioritizeAndDecide";
export default PrioritizeAndDecide;
